import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader, Tab, Responsive
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';
import PollInfo from '../AdminPoll/PollPreviewTabs/PollInfo/PollInfo';
import AdminPollPreview from '../AdminPoll/PollPreviewTabs/PollPreview/AdminPollPreview';
import ProfessorList from './ProfessorList';
import AssistantList from './AssistantList';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';


export default class StaffTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            staffList: { staffQuestionnaireDTOS: [] }

        };
    }


    render() {
        const panes = [
            {
                menuItem: 'Profesori',
                render: () => (<Tab.Pane as={Responsive} attached={false} >
                    <ProfessorList />
                </Tab.Pane>)
            },
            {
                menuItem: 'Asistenti',
                render: () => (<Tab.Pane attached={false} as={Responsive} >
                    <AssistantList />
                    {/* {localStorage.getItem('student')?<StudentPollDetailes />:<AdminPollPreview />} */}
                </Tab.Pane>)
            },


        ];
        return (
            <div>
                <h1>Ankete</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                Osoblje
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('poll')) === 'null' ? ' ' : JSON.parse(localStorage.getItem('poll')).pollName}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>
                </Segment.Group>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/StaffTabs.js